/* archive-home-panel-interactive.js
   Phase A: neon flicker timer
   Phase B: frame nail state machine  (added in phase B)
   Phase C: dry cleaner belt          (added in phase C)
*/

(function () {
  'use strict';

  /* ── Phase A: Neon flicker ───────────────────────────── */

  var label = document.querySelector('.archive-home-panel__label.mullette-neon-label');
  if (!label) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var signOff   = false;
  var animating = false;

  var neonLink = label.closest('a') || label.parentElement;
  if (neonLink && !prefersReducedMotion) {
    neonLink.addEventListener('mouseenter', function () {
      if (animating) return;
      if (!signOff) {
        // Sign is green → flicker → go grey
        animating = true;
        label.classList.add('mullette-neon--flicker');
        label.addEventListener('animationend', function onEnd() {
          label.removeEventListener('animationend', onEnd);
          label.classList.remove('mullette-neon--flicker');
          label.classList.add('mullette-neon--off');
          signOff   = true;
          animating = false;
        }, { once: true });
      } else {
        // Sign is grey → smooth fade to green
        label.classList.add('mullette-neon--smooth');
        label.classList.remove('mullette-neon--off');
        signOff = false;
      }
    });
  }

  /* ── Phase B: Frame nail state machine ──────────────────── */

  var frame = document.querySelector('.archive-home-panel__frame');
  var nailTL = document.querySelector('.archive-panel__nail--tl');
  var nailTR = document.querySelector('.archive-panel__nail--tr');

    var nailPrompt = document.querySelector('.archive-panel__nail-prompt:not(.archive-panel__nail-prompt--second)');
    var nailPromptSecond = document.querySelector('.archive-panel__nail-prompt--second');
    var promptDismissed = false;

    function dismissNailPrompt() {
      if (promptDismissed || !nailPrompt) return;
      promptDismissed = true;
      nailPrompt.classList.add('archive-panel__nail-prompt--hidden');
      if (nailPromptSecond) {
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            nailPromptSecond.classList.remove('archive-panel__nail-prompt--hidden');
          });
        });
      }
    }

  if (frame && nailTL && nailTR) {

    function setFrameState(state) {
      frame.dataset.frameState = state;
    }

    function removeNail(nail, corner) {
      dismissNailPrompt();
      nail.classList.add('archive-panel__nail--removed');
      nail.disabled = true;

      var currentState = frame.dataset.frameState;

      if (currentState === 'idle') {
        // First nail — hang from the remaining corner
        var pivotCorner = (corner === 'tl') ? 'tr' : 'tl';
        frame.style.transformOrigin = (pivotCorner === 'tr') ? 'top right' : 'top left';
        frame.style.setProperty('--drop-angle', (corner === 'tl') ? '-22deg' : '22deg');
        setFrameState('hanging-from-' + pivotCorner);

      } else if (currentState === 'hanging-from-tr' || currentState === 'hanging-from-tl') {
        // Second nail — hide second prompt and drop
        if (nailPromptSecond) nailPromptSecond.classList.add('archive-panel__nail-prompt--hidden');
        startDrop();
      }
    }

    function startDrop() {
      if (prefersReducedMotion) {
        setFrameState('hidden');
        onBeltReady();
        return;
      }

      setFrameState('falling');

      frame.addEventListener('animationend', function onDropEnd() {
        frame.removeEventListener('animationend', onDropEnd);
        setFrameState('hidden');
        onBeltReady();
      }, { once: true });
    }

    function resetFrame() {
      frame.style.transformOrigin = '';
      frame.style.removeProperty('--drop-angle');
      frame.style.visibility = '';
      frame.style.opacity = '';
      setFrameState('idle');

      nailTL.classList.remove('archive-panel__nail--removed');
      nailTR.classList.remove('archive-panel__nail--removed');
      nailTL.disabled = false;
      nailTR.disabled = false;

      promptDismissed = false;
      if (nailPrompt) nailPrompt.classList.remove('archive-panel__nail-prompt--hidden');
      if (nailPromptSecond) nailPromptSecond.classList.add('archive-panel__nail-prompt--hidden');
    }

    /* ── Phase C: Dry cleaner belt ───────────────────────── */

    function onBeltReady() {
      var panel = document.querySelector('.archive-home-panel');
      if (!panel) { setTimeout(resetFrame, 2500); return; }
      fetch('/products.json?limit=250')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .catch(function () { return { products: [] }; })
        .then(function (data) { launchBelt(panel, data.products || []); });
    }

    function launchBelt(panel, products) {
      var hangerUrl = panel.dataset.hangerUrl || '';
      var frameRing = panel.querySelector('.archive-home-panel__frame-ring');
      var frameImgSrc = frameRing ? frameRing.src : '';
      var photo = panel.querySelector('.archive-home-panel__photo');
      var photoSrc = photo ? photo.src : '';

      // Shopify CDN: insert _100x before extension to get thumbnail
      function thumbUrl(src) {
        return src ? src.replace(/(\.[a-z]+)(\?|$)/i, '_100x$1$2') : src;
      }

      // Build shuffled pool of all product images
      var imgPool = [];
      products.forEach(function (p) {
        (p.images && p.images.length ? p.images : []).forEach(function (img) {
          var s = typeof img === 'string' ? img : (img.src || '');
          if (s) imgPool.push({ src: thumbUrl(s), alt: p.title, handle: p.handle });
        });
        if (!(p.images && p.images.length) && p.featured_image) {
          var s = typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image.src || '');
          if (s) imgPool.push({ src: thumbUrl(s), alt: p.title, handle: p.handle });
        }
      });
      for (var si = imgPool.length - 1; si > 0; si--) {
        var sj = Math.floor(Math.random() * (si + 1));
        var st = imgPool[si]; imgPool[si] = imgPool[sj]; imgPool[sj] = st;
      }
      // Cap belt length — keeps load fast; images resized via Shopify CDN suffix
      if (imgPool.length > 10) imgPool.length = 10;
      var items = imgPool.length > 0 ? imgPool : new Array(12).fill(null);
      var frameIndex = Math.floor(items.length * 0.25) +
        Math.floor(Math.random() * Math.max(1, Math.floor(items.length * 0.15)));

      var belt = document.createElement('div');
      belt.className = 'mullette-belt';
      belt.setAttribute('aria-hidden', 'true');

      var rail = document.createElement('div');
      rail.className = 'mullette-belt__rail';
      belt.appendChild(rail);

      var track = document.createElement('div');
      track.className = 'mullette-belt__track';
      belt.appendChild(track);

      var frameBeltItem = null;
      var beltItemIndex = 0;

      function makeHanger() {
        var img = document.createElement('img');
        img.src = hangerUrl;
        img.className = 'mullette-belt__hanger';
        img.setAttribute('aria-hidden', 'true');
        img.alt = '';
        return img;
      }

      function makeItem(imgSrc, alt, isFrame) {
        var el = document.createElement('div');
        el.className = 'mullette-belt__item' + (isFrame ? ' mullette-belt__item--frame' : '');
        el.appendChild(makeHanger());
        var g = document.createElement('div');
        g.className = 'mullette-belt__garment' + (isFrame ? ' mullette-belt__garment--frame' : '');
        if (isFrame && frameImgSrc) {
          // Composite: photo inside, frame-ring on top
          var wrap = document.createElement('div');
          wrap.className = 'mullette-belt__frame-wrap';
          if (photoSrc) {
            var pi = document.createElement('img');
            pi.src = photoSrc;
            pi.alt = '';
            pi.loading = 'eager';
            pi.className = 'mullette-belt__frame-photo';
            wrap.appendChild(pi);
          }
          var fi = document.createElement('img');
          fi.src = frameImgSrc;
          fi.alt = 'Frame';
          fi.loading = 'eager';
          fi.className = 'mullette-belt__frame-ring-img';
          wrap.appendChild(fi);
          g.appendChild(wrap);
        } else if (imgSrc) {
          var img = document.createElement('img');
          img.src = imgSrc;
          img.alt = alt || '';
          img.loading = 'eager';
          g.appendChild(img);
        } else {
          g.innerHTML =
            '<svg viewBox="0 0 72 90" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
            '<rect x="6" y="6" width="60" height="78" rx="2" stroke="#8C8376" stroke-width="1.5" fill="none" opacity="0.35"/>' +
            '</svg>';
        }
        el.appendChild(g);
        return el;
      }

      items.forEach(function (imgData, i) {
        if (i === frameIndex && frameImgSrc) {
          frameBeltItem = makeItem(null, null, true);
          frameBeltItem.style.animationDelay = (-beltItemIndex * 0.28) + 's';
          beltItemIndex++;
          track.appendChild(frameBeltItem);
        }
        var src = imgData ? imgData.src : '';
        var el = makeItem(src, imgData ? imgData.alt : '');
        el.style.animationDelay = (-beltItemIndex * 0.28) + 's';
        beltItemIndex++;
        if (imgData && imgData.handle) {
          (function (h) {
            el.addEventListener('click', function () { window.location.href = '/products/' + h; });
          }(imgData.handle));
        }
        track.appendChild(el);
      });

      if (!frameBeltItem && frameImgSrc) {
        frameBeltItem = makeItem(null, null, true);
        frameBeltItem.style.animationDelay = (-beltItemIndex * 0.28) + 's';
        track.appendChild(frameBeltItem);
      }

      panel.appendChild(belt);

      var panelW = panel.getBoundingClientRect().width || 600;
      track.style.transform = 'translateX(' + panelW + 'px)';

      if (prefersReducedMotion) {
        belt.style.transform = 'translateX(0)';
        scrollTrack(belt, track, frameBeltItem);
        return;
      }

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          belt.classList.add('mullette-belt--visible');
        });
      });

      belt.addEventListener('transitionend', function onIn(e) {
        if (e.target !== belt || e.propertyName !== 'transform') return;
        scrollTrack(belt, track, frameBeltItem);
      }, { once: true });
    }

    function scrollTrack(belt, track, frameBeltItem) {
      var frameRect    = frame.getBoundingClientRect();
      var panel        = belt.parentNode;
      var panelW       = (panel ? panel.getBoundingClientRect().width : 0) || 600;
      var speed        = 4;
      var scrollX      = panelW;
      // Stop when the last item's right edge reaches the panel's right edge
      var finalScrollX = panelW - track.scrollWidth;
      var rafId;

      function stop() {
        cancelAnimationFrame(rafId);
        track.style.transform = 'translateX(' + finalScrollX + 'px)';
        // Let viewer see all items before frame returns
        setTimeout(function () {
          placeFrame(belt, frameBeltItem, frameRect);
        }, prefersReducedMotion ? 0 : 3000);
      }

      if (prefersReducedMotion) { stop(); return; }

      function tick() {
        scrollX -= speed;
        track.style.transform = 'translateX(' + scrollX + 'px)';
        if (scrollX <= finalScrollX || scrollX < -8000) { stop(); return; }
        rafId = requestAnimationFrame(tick);
      }

      rafId = requestAnimationFrame(tick);
    }

    function placeFrame(belt, frameBeltItem, frameRect) {
      var panel = belt.parentNode;

      if (prefersReducedMotion || !panel) {
        finalizeBelt(belt);
        return;
      }

      var frameRing  = panel.querySelector('.archive-home-panel__frame-ring');
      var framePhoto = panel.querySelector('.archive-home-panel__aperture .archive-home-panel__photo')
                    || panel.querySelector('.archive-home-panel__photo');

      if (!frameRing && !framePhoto) {
        finalizeBelt(belt);
        return;
      }

      var wrapEl   = frameBeltItem.querySelector('.mullette-belt__frame-wrap') || frameBeltItem;
      var itemRect = wrapEl.getBoundingClientRect();
      var panelRect = panel.getBoundingClientRect();

      var clone = document.createElement('div');
      clone.style.position        = 'absolute';
      clone.style.top             = (frameRect.top  - panelRect.top)  + 'px';
      clone.style.left            = (frameRect.left - panelRect.left) + 'px';
      clone.style.width           = frameRect.width  + 'px';
      clone.style.height          = frameRect.height + 'px';
      // z-index 200 + will-change forces own compositing layer above belt track (z-index 20)
      clone.style.zIndex          = '200';
      clone.style.willChange      = 'transform';
      clone.style.pointerEvents   = 'none';
      clone.style.transformOrigin = 'top left';
      clone.style.transition      = 'none';

      // Photo inside aperture — mirrors .archive-home-panel__aperture layout
      if (framePhoto) {
        var aperture = document.createElement('div');
        aperture.style.position   = 'absolute';
        aperture.style.top        = '50%';
        aperture.style.left       = '50%';
        aperture.style.transform  = 'translate(-50%, -52%)';
        aperture.style.width      = '71%';
        aperture.style.height     = '74%';
        aperture.style.overflow   = 'hidden';
        aperture.style.background = '#e0d8c8';
        aperture.style.zIndex     = '1';

        var photoClone = document.createElement('img');
        photoClone.src                = framePhoto.src;
        photoClone.alt                = '';
        photoClone.style.width        = '100%';
        photoClone.style.height       = '100%';
        photoClone.style.display      = 'block';
        photoClone.style.objectFit    = 'contain';
        photoClone.style.objectPosition = 'center top';
        aperture.appendChild(photoClone);
        clone.appendChild(aperture);
      }

      // Frame ring on top
      if (frameRing) {
        var ringClone = document.createElement('img');
        ringClone.src              = frameRing.src;
        ringClone.alt              = '';
        ringClone.style.position   = 'absolute';
        ringClone.style.top        = '0';
        ringClone.style.left       = '0';
        ringClone.style.width      = '100%';
        ringClone.style.height     = '100%';
        ringClone.style.objectFit  = 'fill';
        ringClone.style.display    = 'block';
        ringClone.style.zIndex     = '2';
        clone.appendChild(ringClone);
      }

      // FLIP invert: offset clone from target position to belt item position
      var dx = itemRect.left - frameRect.left;
      var dy = itemRect.top  - frameRect.top;
      var sx = itemRect.width  / (frameRect.width  || 1);
      var sy = itemRect.height / (frameRect.height || 1);
      clone.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + sx + ',' + sy + ')';

      panel.appendChild(clone);

      // Hide belt frame item now that clone takes its place
      var wrap = frameBeltItem.querySelector('.mullette-belt__frame-wrap');
      if (wrap) wrap.style.opacity = '0';

      // Play: smooth ease-out glide from belt position to frame position
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          clone.style.transition = 'transform 1.1s cubic-bezier(0.25, 1, 0.5, 1)';
          clone.style.transform  = 'none';
        });
      });

      clone.addEventListener('transitionend', function () {
        if (clone.parentNode) clone.parentNode.removeChild(clone);
        finalizeBelt(belt);
      }, { once: true });
    }

    function finalizeBelt(belt) {
      resetFrame();
      // Raise frame above belt so it doesn't get covered during retraction
      frame.style.zIndex = '25';
      setTimeout(function () { retractBelt(belt); }, 350);
    }

    function retractBelt(belt) {
      if (prefersReducedMotion) {
        frame.style.zIndex = '';
        if (belt.parentNode) belt.parentNode.removeChild(belt);
        return;
      }
      belt.classList.remove('mullette-belt--visible');
      belt.classList.add('mullette-belt--retract');
      belt.addEventListener('transitionend', function onOut(e) {
        if (e.target !== belt || e.propertyName !== 'transform') return;
        frame.style.zIndex = '';
        if (belt.parentNode) belt.parentNode.removeChild(belt);
      }, { once: true });
    }

    nailTL.addEventListener('click', function () {
      var s = frame.dataset.frameState;
      // Allow: idle (first nail) OR hanging-from-tl (TL is the last remaining nail)
      if (s !== 'idle' && s !== 'hanging-from-tl') return;
      removeNail(nailTL, 'tl');
    });

    nailTR.addEventListener('click', function () {
      var s = frame.dataset.frameState;
      // Allow: idle (first nail) OR hanging-from-tr (TR is the last remaining nail)
      if (s !== 'idle' && s !== 'hanging-from-tr') return;
      removeNail(nailTR, 'tr');
    });

  }

})();

